export default __webpack_public_path__ + "static/media/styled-components.a5fa325c.svg";